const BackgroundLogoSvg = (props: any) => {
  return (
    <svg
      width="441"
      height="810"
      viewBox="0 0 441 810"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M-39.9113 179.26C-21.1104 179.26 2.63802 201.472 31.8288 245.403C110.496 339.189 157.993 398.422 174.814 422.608H177.288C190.647 409.281 253.481 331.785 366.286 190.613C371.728 185.677 381.624 181.728 395.972 179.26C425.162 186.171 440.005 199.498 440.005 218.255V232.076C440.005 241.455 412.299 278.475 357.381 342.644L235.175 496.65C371.728 660.527 440.5 746.415 440.5 753.819V767.64C440.5 790.346 425.657 804.167 396.466 809.103H394.487C376.676 809.103 356.391 791.333 334.127 756.287L177.783 565.261C54.5878 718.279 -9.73087 797.256 -16.1627 801.699C-23.5841 806.141 -31.5003 808.609 -39.4165 808.609H-41.3955C-66.1335 808.609 -80.4814 792.32 -85.429 760.236C-85.429 748.389 -56.2383 708.901 2.14326 643.251L119.401 493.688L-81.471 243.429L-85.9238 224.672C-79.492 194.068 -64.1545 179.26 -39.9113 179.26Z"
        fill="url(#paint0_linear_1220_1799)"
      />
      <path
        d="M267.331 88.4375C267.331 137.305 227.75 176.793 178.769 176.793C129.788 176.793 90.207 137.305 90.207 88.4375C90.207 39.5704 129.788 0.0817871 178.769 0.0817871C227.75 0.0817871 267.331 39.5704 267.331 88.4375Z"
        fill="url(#paint1_linear_1220_1799)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1220_1799"
          x1="313.641"
          y1="686.24"
          x2="300.378"
          y2="322.377"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E5E5E5" stopOpacity="0.68" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1220_1799"
          x1="224.647"
          y1="142.322"
          x2="221.543"
          y2="40.1941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E5E5E5" stopOpacity="0.68" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default BackgroundLogoSvg
